import { CalendarDays, Target, User } from 'lucide-react';

export function TwelveMonthPlan({ months }) {
  const list = Array.isArray(months) ? months : [];
  if (list.length === 0) return null;
  return (
    <section id="plano-12-meses" className="acq-section">
      <div className="acq-container">
        <header>
          <span className="kicker">Plano de 12 meses</span>
          <h2>O primeiro ano completo, mês a mês.</h2>
          <p className="section-lead">
            Complementa o plano de 90 dias com a leitura de execução para o resto do ano: foco, responsável e
            ações concretas por mês.
          </p>
        </header>
        <div className="body">
          <div className="twelve-month-grid" data-testid="twelve-month-plan">
            {list.map((m, idx) => (
              <article className="month-card" key={m.month || idx} data-testid={`month-card-${m.month || idx + 1}`}>
                <div className="month-card-head">
                  <span className="month-number">
                    <CalendarDays size={12} /> Mês {m.month || idx + 1}
                  </span>
                  {m.focus && <span className="month-focus" title="Foco do mês"><Target size={11} /> {m.focus}</span>}
                </div>
                <h4>{m.title || `Mês ${m.month || idx + 1}`}</h4>
                {Array.isArray(m.actions) && m.actions.length > 0 && (
                  <ul className="month-actions">
                    {m.actions.filter(Boolean).map((a, i) => <li key={i}>{a}</li>)}
                  </ul>
                )}
                {m.responsible && (
                  <div className="month-responsible" title="Responsável">
                    <User size={11} /> {m.responsible}
                  </div>
                )}
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
